import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import HostCreate from "@/pages/HostCreate";
import HostRoom from "@/pages/HostRoom";
import GuestJoin from "@/pages/GuestJoin";
import GuestRoom from "@/pages/GuestRoom";
import SongCatalogPage from "@/pages/SongCatalogPage";
import SearchAnalyticsPage from "@/pages/SearchAnalyticsPage";
import RoomsPage from "@/pages/RoomsPage";
import {
  DeveloperGate,
  DeveloperConsoleLayout,
  DeveloperDashboardPage,
  DeveloperLoginPage,
  DeveloperPlaceholderPage,
} from "@/pages/DeveloperConsole";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(24,24,27,0.95)",
              border: "1px solid rgba(139,92,246,0.4)",
              color: "white",
              borderRadius: "14px",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/host" element={<HostCreate />} />
          <Route path="/host/:roomCode" element={<HostRoom />} />
          <Route path="/join" element={<GuestJoin />} />
          <Route path="/join/:roomCode" element={<GuestJoin />} />
          <Route path="/guest/:roomCode" element={<GuestRoom />} />
          <Route path="/developer/login" element={<DeveloperLoginPage />} />
          <Route element={<DeveloperGate />}>
            <Route path="/developer" element={<Navigate to="/developer/console" replace />} />
            <Route path="/developer/console" element={<DeveloperConsoleLayout />}>
              <Route index element={<DeveloperDashboardPage />} />
              <Route path="song-catalog" element={<SongCatalogPage />} />
              <Route path="search" element={<SearchAnalyticsPage />} />
                <Route path="rooms" element={<RoomsPage />} />
              <Route path="users" element={<DeveloperPlaceholderPage title="Users" />} />
              <Route path="analytics" element={<DeveloperPlaceholderPage title="Analytics" />} />
              <Route path="system" element={<DeveloperPlaceholderPage title="System" />} />
              <Route path="logs" element={<DeveloperPlaceholderPage title="Logs" />} />
              <Route path="developer-tools" element={<DeveloperPlaceholderPage title="Developer Tools" />} />
              <Route path="feature-flags" element={<DeveloperPlaceholderPage title="Feature Flags" />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
